module.exports = __webpack_public_path__ + "img/heart-icon-empty-evaluation.b1591f58.svg";